import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'


// 图标库
import './assets/iconfont/iconfont.css'
//样式重置
import './styles/normalize.css'
import './styles/common.css'
//百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap,{ak:'KdB9QX3Q7PTu9f2MN0TjTVVXIe9BZmus'})
//eleui
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element, {
  size: 'small',
  zIndex: 99999
})

import API from './utils/request'
Vue.prototype.$service = API.service
//0.01rem = 1px
import './utils/flexible'

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')